<template>
  <v-snackbar
    v-model="show"
    :timeout="-1"
    class="connection-snackbar"
    :class="snackbarOptions.theme"
    :color="snackbarOptions.colour"
    location="bottom left"
  >
    <div class="notification-wrapper d-flex align-center">
      <v-icon class="mr-2"> mdi-lan-disconnect </v-icon>
      {{ $t('general.liveStatusUpdatesDisconnect') }}
    </div>
  </v-snackbar>
</template>

<script>
import { get } from 'lodash';
import { mapState, mapStores } from 'pinia';

// Stores
import { useContextStore } from '@/stores/context';
import { useEventsStore } from '@/stores/events';

// This component is intended to be used to display a warning to the user when the tool loses connection
// to the server and is not going to be receiving live events to auto update the screen
export default {
  data() {
    return { show: false };
  },

  computed: {
    ...mapState(useContextStore, ['getClientConfig']),
    ...mapStores(useEventsStore),
    snackbarOptions() {
      return get(this.getClientConfig, 'snackbars.connection', {});
    },
  },

  created() {
    this.eventsStore.$onAction(({ name, store }) => {
      if (name === 'setEventStreamConnectionProblemStatus') {
        this.show = store.eventStreamConnectionHasProblem;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.notification-wrapper {
  word-wrap: break-word;
}

.connection-snackbar {
  &.dark {
    color: $assortment-snackbar-dark-colour;
  }

  &.light {
    color: $assortment-snackbar-light-colour;
  }
}
</style>
